import { gql } from '@apollo/client'

export const GET_REMINDERS_COUNT_BY_USER = gql`
  query GetUnviewedRemindersCount {
    getUnviewedRemindersCount
  }
`
